/** @module */

import * as parser from './parser.js'
import validate from './validator.js'

/**
 * Compile the code into an AST.
 *
 * Runs the code through the parser and validator.
 *
 * @param {string} code
 * @returns {Array.<AstCommand>}
 *
 * @throws {Error} If the code is invalid
 */
export async function compile (code) {
  let ast
  try {
    ast = parser.parse(code)
  } catch (e) {
    throw new Error(
      `${e.message} at line ${e.location.start.line}, column ${e.location.start.column}`
    )
  }

  try {
    validate(ast)
  } catch (error) {
    throw new Error(error.message)
  }

  return ast
}
